import Fetcher from '../../../services/Fetcher'
import { API_DICTIONARY, HTTP_METHODS } from '../../../constants'
import { GPOItem, GPORequest, GPOResponse } from './types'

const fetcher = new Fetcher({})

export const getGpoList = async (params) =>
  fetcher.request<GPORequest, GPOResponse>({
    url: `${API_DICTIONARY.MY_COMMUNITY}${API_DICTIONARY.GPO}`,
    method: HTTP_METHODS.GET,
    ...params
  })
export const getGpoDetailsList = async (uuid) =>
  fetcher.request<unknown, GPOItem>({
    url: `${API_DICTIONARY.MY_COMMUNITY}${API_DICTIONARY.GPO}${uuid}/`,
    method: HTTP_METHODS.GET
  })

export const addNewGpo = (data: Partial<GPOItem>) =>
  fetcher.request<unknown, unknown>({
    url: `${API_DICTIONARY.MY_COMMUNITY}${API_DICTIONARY.GPO}`,
    method: HTTP_METHODS.POST,
    data
  })

export const updateGpoDetails = (id: string, data: Partial<GPOItem>) =>
  fetcher.request<unknown, unknown>({
    url: `${API_DICTIONARY.MY_COMMUNITY}${API_DICTIONARY.GPO}${id}/`,
    method: HTTP_METHODS.PATCH,
    data
  })
